// removed by extract-text-webpack-plugin
module.exports = {"contentPlaceholder":"_3SFHtvsDz7jqMCipBn2wwo","retangle":"_1xZOQsEf75e8bImdhE4hNN","box":"_3b3cPxpd-l55MzA4tEJrb3","circle":"_1PE65mzQbOpw9HgI2SXRHd","line":"_32AsHvw4VLkdbCqGx7KvyT","header":"_38lXJyfIrnmuOcbJaIl2A-","blink":"_3FQgiiuwKHjHUAX1psIdJn"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/PlaceHolder/style.css
// module id = 364
// module chunks = 37